export const locale = {
  lang: 'en',
  data: {
    'ALERTS':{
      'OK':'OK'
    },
    'CIERRE': {
      'CARGANDO':'Loanding data',
      'CARGANDOCORREO':'Please, wait a moment...',
      'LABEL1': 'Participation rate',
      'LABEL2': 'See progress',
      'LABEL3': 'Survey completed',
      'LABEL4': 'See result',
      'LABEL5': 'The reminders has been sending',
      'LABEL6': 'You already has send an email today',
      'LABEL7': 'You only can send reminders after your launch day',
      'LABEL8': 'Wait a minute......',
      'LABEL9': 'Remaining days',
      'BTN_CIERRE': 'Close now',
      'ALERT':{
        'MESSAGE': 'Do you confirm to perform the anticipated survey close?',
        'BTN_CONFIRM': 'Yes',
        'BTN_CANCEL': 'No',
        'OK':'OK',
      },
      'ALERT_RE':{
        'MESSAGE': '¿Are you sure you want to send the reminders?',
        'BTN_CONFIRM': 'Yes',
        'BTN_CANCEL': 'No',
        'OK':'OK',
      },
      'LINK': 'Go to the next link to see the survey current progress',
      'LINKENCUESTA': 'Generates the link to view the current progress of the survey',
      'ACTIONS':{
        'TITULO': 'Actions',
        'TITULO_ACTUALIZADO': 'Reminders',
        'TITULO_ACCESS': 'Access to survey',
        'WANNADO': 'What do you want to do?',
        'TITULO_VIRSMS': 'Virtual SMS portal',
        'TITULO_MYCODE': 'GetMyCode.culturalgo.com portal',
        'TITULO_BTNMYCODE': 'Go to GetMyCode portal',
      },
      'COMPLETO':{
        'TAG': 'The survey is finished successfully',
        'CARDTIT': 'Results query',
        'LINK': 'Go to the next link to see the obtained results in the survey'
      },
      'PORTAL':{
        'LABEL01':'Counting portal',
        'LABEL02':'Generate access key'

      },
      'PULSE':{
        /// Survey advancement
        'LABELPRO':'Survey progress',
        'LINKEN': 'Survey link',
        'LINKRES': 'Link result ',
        'ENCUESTANOENVIADA': 'No Pulse Check survey has been released yet',
      },
      'CIERRE':{
        'BCONTEOS':'Counting portal',
        'BACCESO':'Generate access key',
        'LINKPORTAL': 'Copy access link to counting portal',
        'COPYLINK':'Copied to your clipboard',
        'REMANDERC2':'Reminder to people who has not finish the survey',
        'REMANDER':'Reminders',
        'REMANDER1':'Reminders to people who have started and still do not finish',
        'REMANDER2':'Reminders to people who have started and still do not finish',
        'REMANDER_TURQUIA':'Send reminders to all participants',
        'GETURLSURV_1': 'Generate survey access provider link',
        'GETURLSURV_2': 'The link for the survey access provider was generated, now you can copy it by clicking on the same button',
        'GETURLSURV_3': 'Copy survey access provider link',
        'ASIGUSERDEMO':'Assigning a password',
      },
      'MOD_TEX_SEND_RECO':'Sending email...',

    },
  }
};
